import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import GMIsland from '@/views/misc/GMIsland'
import ExpiredSubs from '@/views/misc/ExpiredSubs'

import store from '@/store'
import API from '@/api'

import dashboard from './dashboard/dashboard.router'
import auth from './auth.router'
import misc from './misc.router'

Vue.use(Router);

const router = new Router({
  
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index,
      beforeEnter: multiguard([ middleware.isUnlogged ]),
    },
    {
      path: '/gm-island',
      name: 'gm-island',
      component: GMIsland,
    },
    {
      path: '/expired-subs',
      name: 'expired-subs',
      component: ExpiredSubs,
    },
    ...auth,
    dashboard,
    ...misc,
  ]
})

router.beforeEach(async (to, from, next) => {

  if(to.meta.title) {
    const prefix = process.env['VUE_APP_WHITELABEL'] === 'digifarm' ? 'Digifarm' : 'i-PlantNutrition';
    document.title = prefix + ' | ' + to.meta.title;
  }

  // required
  if(!store.getters['user/isLoaded']) {
    if(store.getters['user/token']) {
      await API.user.getData(store.getters['user/token'])
        .then(res => {
          store.commit('user/auth', store.getters['user/token']);
          store.commit('user/saveData', res.data.user);
          store.commit('user/saveSubsStatus', res.data.subsStatus);
        })
        .catch(err => {
          console.error('Invalid auth token.');
        });
    }
    store.commit('user/load');
  }

  if(store.getters['user/isLogged']) {
    //make rtl
    // let rtlLanguages = ['jp', 'he', 'Jojorefference']
    // if(rtlLanguages.includes(store.getters['user/lang'])) {
    //   document.body.setAttribute('dir', 'rtl')
    // }
    if(!store.getters['farms/isLoaded']) {
      await store.dispatch('farms/updateData');
    }

    if(!store.getters['user-crops/isLoaded']) {
      store.dispatch('user-crops/updateData').catch(err => undefined);
    }

    if(!store.getters['user-settings/isLoaded']) {
      store.dispatch('user-settings/updateData');
    }

    if(!store.getters['notes/isConnected'] && !store.getters['notes/isBusy']) {
      try {
        store.dispatch('notes/connect');
      } catch (error) {
        console.error('Could not connect to WS server', error);
      }
    }
  }

  // required
  if(!store.getters['nutrients/isLoaded']) {
    await store.dispatch('nutrients/loadNutrients');
  }

  if(!store.getters['tutorials/isLoaded']) {
    store.dispatch('tutorials/updateData');
  }

  if(!store.getters['countries/isLoaded']) {
    store.dispatch('countries/updateData');
  }

  if(!store.getters['misc/getVersion']) {
    API.misc.getVersion().then(res => {
      store.commit('misc/setVersion', res.data.version);
    })
  }

  next();
});

export default router;
